export const PROPERTY_MAP_ADDRESS = {
  property: 'postal_address',
  availability: 'property.postal_address',
};
